import api from './api';

export const manualAdjustWallet = async (data) => {
  const response = await api.post('/admin/wallet/manual-adjust/', data);
  return response.data;
};

export const fetchWalletLogs = async (params = {}) => {
  const response = await api.get('/admin/wallet/manual-logs/', { params });
  return response.data;
};

export const fetchWallets = async (params = {}) => {
  const response = await api.get('/admin/wallet/wallets/', { params });
  return response.data;
};

export const searchUsers = async ({ search, role }) => {
  const params = { page_size: 20 };
  if (role) params.role = role;
  if (search) params.search = search;
  const response = await api.get('/admin/users/', { params });
  return response.data;
};


